import React, { useRef, useEffect } from 'react';

const PrintIframe = (props) => {
  const { SelectedRadio, PrintableItems, CheckedItems, SetPrintClicked } =
    props;
  const iframeRef = useRef(null);

  const prepareContent = () => {
    if (iframeRef.current) {
      const doc =
        iframeRef.current.contentDocument ||
        iframeRef.current.contentWindow.document;

      var printItems = PrintableItems;

      if (SelectedRadio !== 1) {
        const filteredItems = PrintableItems?.filter((item) => {
          return CheckedItems?.includes(item);
        });
        printItems = filteredItems;
      }

      const styleElements = Array.from(
        document.querySelectorAll('style')
      ).filter((style) => style.id !== 'onetrust-style');
      var styleContent = styleElements.map((style) => style.outerHTML).join('');

      const headerMainDiv = document.querySelector('.c-header__main');
      const headerMainHTML = headerMainDiv ? headerMainDiv.outerHTML : '';
      const regionLabel = document.querySelector('.regionlabel');
      const regionLabelHTML = regionLabel ? regionLabel.outerHTML : '';

      const outerHTML =
        printItems?.map((item) => item.outerHTML).join('') ?? '';

      const updatedOuterHTML = outerHTML.replace(
        /\/\/play\.media/g,
        'https://play.media'
      );

      doc.open();
      doc.write(`
        <html>
          <head>
            ${styleContent}
            <style>
              @media print {
                @page {
                  margin: 2cm;
                }
                body, html {
                  height: 100%;
                }
                body > * {
                  page-break-after: avoid;
                  page-break-inside: avoid;
                  break-inside: avoid;
                  break-after: avoid;
                  clear: both;
                }
                img {
                  width: auto !important;
                  height: auto !important;
                  max-height: 400px !important;
                  max-width: 100% !important;
                }
                a {
                  color: #353535 !important;
                  text-decoration: none !important;
                }
                .logo__link {
                  left: 0px;
                  top: 40px
                }
                .logo__link svg {
                  fill: #353535;
                }
                .c-header__main {
                  float: none;
                  width: 100%;
                  padding-left: 0 !important;
                  padding-right: 0 !important;
                }
                .c-articleheader__heading {
                  clear: both !important;
                }
                .c-header__logo {
                  margin-bottom: 40px;
                }  
                .c-header__search-mobile {
                  display: none;
                }
                .header-tools__regions, .c-header-tools {
                  display: none;
                }
                iframe, .c-video {
                  display: none;
                }
                .region-logo__container:before {
                  background-color: transparent !important;
                }
                .region-logo__container:after {
                  background-color: transparent !important;
                }
                .region-logo__container {
                  background-color: transparent;
                  right: 0px;
                  top: 32px;
                  width: auto !important;
                }
                .region-logo__img__vastragotaland {
                  height: 60px;
                  top: 0px;
                }
                #region-background {
                  fill: none;
                }
                .region-logo__img mask {
                  display: none;
                }
                .region-logo__img path {
                  fill: #353535;
                }
                .c-articlefooter__wrapper{
                  margin-top: 40px;
                }
                .c-articlefooter__content {
                  margin-left: 0;
                }
                .c-articlefooter__content .columns {
                  padding-left: 0;
                }
                .c-action-table__large-headings {
                  display: none;
                }
                .c-action-table__column__heading {
                  font-size: 18px;
                  font-weight: 700;
                }
                .c-media-gallery__item__text-container {
                  visibility: visible !important;
                }
                .c-highlight--important, 
                .c-highlight--importantinfo, 
                .c-highlight--localinstructions, 
                .c-highlight--recommendations, 
                .c-highlight--routines {
                    padding-left: 15px;
                }
                .c-highlight--color1, .c-highlight--frame {
                    border: 1px solid #737373;
                    border-radius: 10px;
                }
                .c-chapter--regional-content::before {
                    content: attr(data-print-sidebar-title-region);
                    color: #3b4266;
                    font-weight: bold;
                    display: block;
                    margin-top: 15px;
                    
                }
                .c-chapter--regional-content {
                    border: 1px solid #3b4266;
                    border-radius: 10px;
                    padding-left: 20px;
                    padding-bottom: 20px;
                    margin-top: 20px;
                }
                .regionlabel {
                  position: relative;
                  top: 0px;
                  left: 0;
                  color: #3b4266;
                  font-size: 0.875rem;
                  display: block;
                  padding: 0px 0px;
                }
                .c-image {
                  opacity: 1 !important;
                  transition: none !important;
                }
                .c-image-gallery__current {
                  display: none;
                }
              }
            </style>
          </head>
          <body>
            ${headerMainHTML}
            ${regionLabelHTML}
            ${updatedOuterHTML}
          </body>
        </html>
      `);

      const elements = doc?.querySelectorAll('.regional-container');
      elements?.forEach((element) => element.remove());
      doc.close();
    }
  };

  const handleLoad = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.focus();
      iframeRef.current.contentWindow.print();
      SetPrintClicked(false);
    }
  };

  useEffect(() => {
    const initializeIframe = async () => {
      prepareContent();
    };

    initializeIframe();
  }, [SelectedRadio, PrintableItems, CheckedItems]);

  return (
    <>
      <iframe
        ref={iframeRef}
        style={{
          display: 'block',
          backgroundColor: 'white',
          width: 1000,
          height: 1000,
          position: 'absolute',
          top: -9999,
          left: -9999,
          zIndex: -1,
        }}
        title="Skriv ut"
        onLoad={handleLoad}
      />
    </>
  );
};

export default PrintIframe;
